import { Button, Stack, styled } from 'canoe';
import React, { ChangeEvent } from 'react';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';
import { useToggle } from 'commons/hooks';
import { useMultiNodes } from 'craft/hooks';

// Pads button so the toolbox doesn't jump when it turns into the input
const PaddedButton = styled(Button)`
  margin-bottom: 10px;
`;

interface Props {
  nodeIds: string[];
}

export const ComponentCssClass = ({ nodeIds }: Props) => {
  const res = useMultiNodes(nodeIds);
  const {
    props,
    actions: { setProps },
  } = res;

  const initialValue = props.className?.value;
  const [isOpen, toggle] = useToggle(!!initialValue);

  // only allow className to be customized for nodes that support it in the schema
  if (!props.className) {
    return null;
  }

  const onValueChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setProps({ className: value });
  };

  if (!isOpen) {
    return (
      <Stack justify="flex-end">
        <PaddedButton size="xsmall" variant="contrast" appearance="text" onClick={toggle} mb="xs">
          + Add a CSS class
        </PaddedButton>
      </Stack>
    );
  }

  return (
    <ValueBox label="CSS class">
      <ValueInput value={initialValue} placeholder="next-button btn-sml" onChange={onValueChange} />
    </ValueBox>
  );
};
